import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@/_assets/styles/global.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//  ██████╗ █████╗ ███╗   ██╗██████╗  ██████╗  ██████╗     ███████╗███╗   ███╗███████╗
// ██╔════╝██╔══██╗████╗  ██║██╔══██╗██╔═══██╗██╔═══██╗    ██╔════╝████╗ ████║██╔════╝
// ██║     ███████║██╔██╗ ██║██║  ██║██║   ██║██║   ██║    ███████╗██╔████╔██║███████╗
// ██║     ██╔══██║██║╚██╗██║██║  ██║██║   ██║██║   ██║    ╚════██║██║╚██╔╝██║╚════██║
// ╚██████╗██║  ██║██║ ╚████║██████╔╝╚██████╔╝╚██████╔╝    ███████║██║ ╚═╝ ██║███████║
//  ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝  ╚═════╝  ╚═════╝     ╚══════╝╚═╝     ╚═╝╚══════╝
// Behzad Bakhshayesh
